import React from 'react';
import PropTypes from 'prop-types';
import FolderHeader from './FolderHeader';
import ContentTeaser from '../Global/Teasers/ContentTeaser';

const FolderPanel = ({ parentId, item, onNewFolderClick, canShare, onShareFolderClick, onEditFolderClick }) => {
  if (parentId !== null && item.type === `folder`) {
    return (
      <FolderHeader
        folder={item}
        onNewFolderClick={() => onNewFolderClick(item)}
        canShare={canShare}
        onShareClick={() => onShareFolderClick(item)}
        onEditClick={() => onEditFolderClick(item)}
      />
    );
  }

  const { title, slug, plaintext_summary, author_full_name, type, tcm_age_range, usa_age_range, thumbnail_image_url, stream_image_url, has_video, is_new } = item;
  return (
    <div className="item-preview p-a-5 d-flex align-items-center h-100">
      <ContentTeaser
        href={slug}
        title={title}
        summary={plaintext_summary}
        authorName={author_full_name}
        type={type}
        tcmAgeRange={tcm_age_range}
        usaAgeRange={usa_age_range}
        heroImage={thumbnail_image_url}
        streamImage={stream_image_url}
        hasVideo={has_video}
        isNew={is_new}
        showImage
        classes="w-100"
      />
    </div>
  );
};

FolderPanel.propTypes = {
  parentId: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  onNewFolderClick: PropTypes.func.isRequired,
  canShare: PropTypes.bool,
  onShareFolderClick: PropTypes.func.isRequired,
  onEditFolderClick: PropTypes.func.isRequired,
};

export default FolderPanel;



// WEBPACK FOOTER //
// ./library/app/components/Folders/FolderPanel.js